package fi.bullpen.kmpapp.data.utils

import kotlinx.serialization.Serializable

@Serializable
data class HttpHeader(
    val key: String,
    val value: String,
)